import type { SormContext, SormEntityName } from '../gen/sorm-schema.generated'

/** SORM query context for proposal-grain entities. */
export const PROPOSAL_ENTITY_CONTEXT = 'proposal' satisfies SormContext

/** SORM query context for trade-plan entities. */
export const TRADE_PLAN_ENTITY_CONTEXT = 'trade_plan' satisfies SormContext

/** SORM query context for portfolio-strategy entities. */
export const PORTFOLIO_STRATEGY_ENTITY_CONTEXT =
  'portfolio_strategy' satisfies SormContext

/** SORM query context for account-group entities. */
export const ACCOUNT_GROUP_ENTITY_CONTEXT =
  'account_groups' satisfies SormContext

/** SORM query context for team entities. */
export const TEAM_ENTITY_CONTEXT = 'teams' satisfies SormContext

export const TRADING_GROUP_ENTITY_CONTEXT =
  'trading_groups' satisfies SormContext

/** SORM query context for object groups of every object type. */
export const OBJECT_GROUP_ENTITY_CONTEXT = 'object_groups' satisfies SormContext

/** SORM query context for workflow-run entities. */
export const WORKFLOW_RUN_ENTITY_CONTEXT = 'workflow_runs' satisfies SormContext

/** SORM query context for general User Views. */
export const USER_ENTITY_CONTEXT = 'users' satisfies SormContext

const DEFAULT_ENTITY_CONTEXT = 'clients' satisfies SormContext

const ENTITY_CONTEXTS = {
  Proposal: PROPOSAL_ENTITY_CONTEXT,
  ProposalPosition: PROPOSAL_ENTITY_CONTEXT,
  ProposalLot: PROPOSAL_ENTITY_CONTEXT,
  ProposalOrder: PROPOSAL_ENTITY_CONTEXT,
  ProposalBalance: PROPOSAL_ENTITY_CONTEXT,
  ReportingHolding: PROPOSAL_ENTITY_CONTEXT,
  ReportingAccountStats: PROPOSAL_ENTITY_CONTEXT,
  ReportingCashflow: PROPOSAL_ENTITY_CONTEXT,
  ReportingHydration: PROPOSAL_ENTITY_CONTEXT,
  TradePlan: TRADE_PLAN_ENTITY_CONTEXT,
  Strategy: PORTFOLIO_STRATEGY_ENTITY_CONTEXT,
  AssetAllocationTemplate: PORTFOLIO_STRATEGY_ENTITY_CONTEXT,
  AccountGroup: ACCOUNT_GROUP_ENTITY_CONTEXT,
  Team: TEAM_ENTITY_CONTEXT,
  TeamMember: TEAM_ENTITY_CONTEXT,
  ObjectGroup: OBJECT_GROUP_ENTITY_CONTEXT,
  ObjectGroupAccess: OBJECT_GROUP_ENTITY_CONTEXT,
  ObjectGroupMembership: OBJECT_GROUP_ENTITY_CONTEXT,
  TradingGroup: TRADING_GROUP_ENTITY_CONTEXT,
  User: USER_ENTITY_CONTEXT,
  WorkflowSession: WORKFLOW_RUN_ENTITY_CONTEXT,
  WorkflowLog: WORKFLOW_RUN_ENTITY_CONTEXT,
} satisfies Partial<Record<SormEntityName, SormContext>>

const ENTITY_CONTEXT_BY_NAME = new Map<string, SormContext>(
  Object.entries(ENTITY_CONTEXTS),
)

export function getEntityContext(entityName: string): SormContext {
  return ENTITY_CONTEXT_BY_NAME.get(entityName) ?? DEFAULT_ENTITY_CONTEXT
}
